import { styled as e, Box as i, Typography as m, useTheme as h, useMediaQuery as x } from "@mui/material";
import { ACCOUNT_TAG_PADDING as d } from "../../constants/login.js";
import { padNumber as f } from "../../../common-lib/utils/string.js";
import u from "../../../temp-lib/assets/icons/icon-user.svg.js";
import y from "../../../temp-lib/components/share/apeiron/ApeironEllipsisTypography.js";
import { SkeletonTypography as g } from "../../../temp-lib/components/share/generic/Skeleton.js";
import w from "../../../temp-lib/components/share/next/Image.js";
import * as b from "ramda";
import { useTranslation as A } from "react-i18next";
import { jsxs as t, jsx as o } from "react/jsx-runtime";
const T = e(w)`
  aspect-ratio: 1;
  flex-shrink: 0;
  width: 32px;
`, C = e(i)`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 4px;
  height: 100%;
  justify-content: center;
`, M = e(i)`
  align-items: center;
  gap: 2px;
  display: flex;
  width: 100%;
`, N = e(g)`
  font-size: 14px;
  line-height: 14px;
  max-width: 115px;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  .Custom-Skeleton {
    height: 12px;
    width: 115px;
  }
`, k = e(m)`
  color: #b1b2b2;
  font-size: 14px;
  line-height: 14px;
`, I = e(i)`
  display: flex;
  column-gap: 4px;
`, U = e(y)`
  color: #b1b2b2;
  font-size: 12px;
  line-height: 12px;
  max-width: 192px; // set 192px here as react-middle-ellipsis truncate width is un-predictable
  text-align: left;
  .Custom-Skeleton {
    min-width: 156px;
    height: 10px;
  }
`, O = ({
  name: s,
  tag: p,
  walletAddress: n,
  loading: r
}) => {
  const {
    t: c
  } = A(), l = h(), a = x(l.breakpoints.down("res1024"));
  return /* @__PURE__ */ t(I, {
    children: [/* @__PURE__ */ o(T, {
      src: u
    }), !a && /* @__PURE__ */ t(C, {
      children: [/* @__PURE__ */ t(M, {
        children: [/* @__PURE__ */ o(N, {
          loading: r,
          children: s
        }), /* @__PURE__ */ t(k, {
          children: ["#", f(p, d)]
        })]
      }), /* @__PURE__ */ o(U, {
        loading: r,
        children: b.isEmpty(n) ? `( ${c("account.no_wallet_address")} )` : n
      })]
    })]
  });
};
export {
  O as default
};
//# sourceMappingURL=AccountInfo.js.map
